<mat-slide-toggle
  [labelPosition]="labelPosition"
  [disabled]="disabled()"
  [class]="color"
  [color]="'primary'"
  [(ngModel)]="value"
  (blur)="onTouch()">
  {{ label }}
</mat-slide-toggle>
